<template>
  <div>
    <JadeBox hasPadding>
      <div class="personalization__img--container">
        <img :src="require(`@/assets/kyc/step_2.svg`).default" />
      </div>
      <div class="personalization__text--container">
        <jade-text
          weight="bold"
          variant="heading-small"
        >
          {{ $t('title') }}
        </jade-text>
        <jade-text
          variant="text-medium"
          color="medium"
        >
          {{ $t('subtitle') }}
        </jade-text>
      </div>

      <jade-button
        size="medium"
        class="personalization__button--container"
        @click="redirectToPersonalization"
        icon="shop"
        :variant="variant"
      >
        {{ $t('button') }}
      </jade-button>
    </JadeBox>
  </div>
</template>

<script>
import JadeBox from '@jade/JadeBox/index.vue'
import JadeText from '@jade/JadeText/index.vue'
import JadeButton from '@jade/JadeButton/index.vue'
import BUTTON_VARIANTS from '@jade/enums/button-variants.enum.js'
export default {
  name: 'Personalization',
  components: {
    JadeButton,
    JadeText,
    JadeBox
  },
  methods: {
    redirectToPersonalization () {
      const onboardingURL = process.env.VUE_APP_URL_ONBOARDING
      window.location.href = `${onboardingURL}/#/${this.merchantId}/${this.accountId}`
    }
  },
  props: {
    accountId: String,
    merchantId: String
  },
  computed: {
    variant () {
      return BUTTON_VARIANTS.PRIMARY_SOLID
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.personalization__img--container {
  display: flex;
  justify-content: center;
  padding-bottom: var(--global-space-300, 24px);
}
.personalization__text--container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--global-space-200, 16px);
  padding-bottom: var(--global-space-300, 24px);

  text-align: center;
}

.personalization__button--container {
  width: 100%;
}
</style>
<i18n>
  {
    "pt-BR": {
      "title": "Personalize sua conta",
      "subtitle": "Separamos algumas perguntas pra você nos ajudar a oferecer um serviço melhor.",
      "button": "Iniciar personalização"
    },
    "en-US": {
      "title": "Customize your account",
      "subtitle": "We have selected some questions to help us on offering a better service.",
      "button": "Start customization"
    }
  }
  </i18n>
